import { Injectable } from '@angular/core'
import { Observable } from 'rxjs'
import { AuthHttpService } from 'app/shared/auth-http.service'
import { EnvironmentService } from 'app/environment.service'
import { ISplitUserBookings } from 'app/amendment/bookings/bookings.interfaces'
import { toParamsObj } from 'app/shared/utils';

@Injectable()
export class BookingsService {

    private orchestationUrl

    constructor(
        private authHttp: AuthHttpService,
        private environmentService: EnvironmentService) {
        
            this.orchestationUrl = this.environmentService.getOrchestrationUrl()
    }

    public getBookings(userId: string, locale: string): Observable<ISplitUserBookings> {
        let params = {
            'userId': userId,
            'locale': locale
        }

        const url = `${this.orchestationUrl}/reservations`
        return this.authHttp.get<ISplitUserBookings>(url, { params: toParamsObj(params) })
    }
}
